import __C from '../../primitives/_constant_'
import Api from './api'
import Url from './request.url'

export default class FileApi extends Api {

  constructor() {
    super()
  }

  download(fileId, config) {
    return new Promise(reslove => {
      this.axios().get(`${Url.file.download}/${fileId}`, config).then(res => {
        reslove(res.data)
      })
    })
  }
  getOptionsList() {
    return new Promise(reslove => {
      this.axios().get(`${Url.file.gallery.list}`).then(res => {
        reslove(res.data)
      })
    })
  }
  getFilterOptionsList() {
    return new Promise(reslove => {
      this.axios().get(`${Url.file.gallery.filterlist}`).then(res => {
        reslove(res.data)
      })
    })
  }
  getEditInfo(idx) {
    return new Promise(reslove => {
      this.axios().get(`${Url.file.gallery.edit}/${idx}`).then(res => {
        reslove(res.data)
      })
    })
  }
  getFilesFromGallery(params) {
    return new Promise(reslove => {
      this.axios().post(Url.file.gallery.files, params).then(res => {
        reslove(res.data)
      })
    })
  }
  getFilesFromCategory() {
    return new Promise(reslove => {
      this.axios().get(Url.file.category.files).then(res => {
        reslove(res.data)
      })
    })
  }
  putFile2Gallery(file) {
    return new Promise(reslove => {
      this.axios().put(Url.file.gallery.file, file).then(res => {
        reslove(res.data)
      })
    })
  }
  putFile2Category(file) {
    return new Promise(reslove => {
      this.axios().put(Url.file.category.file, file).then(res => {
        reslove(res.data)
      })
    })
  }
  updFile2Gallery(file) {
    return new Promise(reslove => {
      this.axios().post(Url.file.gallery.file, file).then(res => {
        reslove(res.data)
      })
    })
  }
  updFile2Category(file) {
    return new Promise(reslove => {
      this.axios().post(Url.file.category.file, file).then(res => {
        reslove(res.data)
      })
    })
  }
  updFile2Product(file) {
    return new Promise(reslove => {
      this.axios().post(Url.file.product.file, file).then(res => {
        reslove(res.data)
      })
    })
  }
  delFileFromGallery(idx, fileId) {
    return new Promise(reslove => {
      this.axios().delete(`${Url.file.gallery.file}/${idx}/${fileId}`).then(res =>  { 
        reslove(res.data) 
      })
    })
  }
  delFileFromCategory(idx, fileId) {
    return new Promise(reslove => {
      this.axios().delete(`${Url.file.category.file}/${idx}/${fileId}`).then(res =>  { 
        reslove(res.data) 
      })
    })
  }
  delFileFromProduct(idx, fileId) {
    return new Promise(reslove => {
      this.axios().delete(`${Url.file.product.file}/${idx}/${fileId}`).then(res =>  { 
        reslove(res.data) 
      })
    })
  }
}
